import { Input } from "antd";
import styles from "./ApprovalHistory.module.scss";

type Status = "Approved" | "Rejected" | "Completed" | "canceled" | "created";

export interface IApprovalHistory {
  name: string;
  status: Status;
  date: string;
  reason?: string;
}

interface Props {
  items: IApprovalHistory[];
  language: "vi" | "en";
  emptyText: string;
  showComment: boolean;
  value: string;
  onChange: (value: string) => void;
}

const onChangeFallback = (value: string) => {};

export const ApprovalHistory = ({
  items = [],
  language = "vi",
  emptyText = "Chưa có lịch sử phê duyệt nào!",
  showComment = false,
  value = "",
  onChange = onChangeFallback,
}: Partial<Props>) => {
  const renderedContent = items.map((item, index) => {
    const { name, status, date } = item;

    const renderedStatusContent = (status: Status) => {
      if (status === "created") {
        return language === "vi" ? "đã khởi tạo " : "created ";
      }
      if (status === "Approved") {
        return language === "vi" ? "đã phê duyệt " : "approved ";
      }
      if (status === "Rejected") {
        return language === "vi" ? "đã từ chối " : "rejected ";
      }
      if (status === "Completed") {
        return language === "vi" ? "đã hoàn tất " : "completed ";
      }
      if (status === "canceled") {
        return language === "vi" ? "đã huỷ bỏ " : "cancelled ";
      }
      return null;
    };

    const renderedDateContent = (date: string) => {
      return language === "vi" ? `vào lúc (${date}) ` : `at (${date}) `;
    };

    const renderedReasonContent = (reason?: string) => {
      if (!reason) return null;
      return language === "vi" ? (
        <>
          với lý do <span style={{ fontWeight: 500 }}>{reason} </span>
        </>
      ) : (
        <>
          with reason <span style={{ fontWeight: 500 }}>{reason} </span>
        </>
      );
    };

    return (
      <div key={index}>
        <span className={styles.name}>{name} </span>
        {renderedStatusContent(status)}
        {renderedReasonContent(item.reason)}
        {renderedDateContent(date)}
      </div>
    );
  });

  const emptyContent = emptyText;

  return (
    <div className={styles.container}>
      {items.length ? renderedContent : emptyContent}
      {showComment && (
        <Input.TextArea placeholder="Nhập lý do..." value={value} onChange={(e) => onChange(e.target.value)} />
      )}
    </div>
  );
};
